import { useEffect } from 'react';
import ReactGa from 'react-ga';
import { useLocation } from 'react-router-dom';
import React from 'react';

ReactGa.initialize('UA-81524201-1');

const withAnalytics = (WrappedComponent, options = {}) => {
    const trackPage = (page) => {
        if (process.env.NODE_ENV === 'production') {
            ReactGa.set({
                page,
                ...options,
            });
            ReactGa.pageview(page);
        }
    };

    const HOC = (props) => {
        const location = useLocation();
        useEffect(() => trackPage(location.pathname), [location.pathname]);

        return <WrappedComponent {...props} />;
    };

    return HOC;
};

export { withAnalytics };
